import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { SERVER_URL, REFRESH_SECONDS } from '../constants';
import List from '@mui/material/List';
import AppointmentsListItem from './AppointmentsListItem';
import ConfirmDialog from './ConfirmDialog';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AddAppointment from './AddAppointment';
import { USER_TYPE_CUSTOMER, USER_TYPE_GUEST } from '../constants';
import { getEstimatedTime } from '../helpers/Helpers';
import AppointmentsListItemFixedSched from './AppointmentsListItemFixedSched';

function Appointments(props) {
    useEffect(() => {
        fetchAppointments();
    }, []);

    const [focus, setFocus] = useState(document.hasFocus());
    const useHasFocus = () => {
        // get the initial state

        useEffect(() => {
            // helper functions to update the status
            const onFocus = () => setFocus(true);
            const onBlur = () => setFocus(false);

            // assign the listener
            // update the status on the event
            window.addEventListener("focus", onFocus);
            window.addEventListener("blur", onBlur);

            // remove the listener
            return () => {
            window.removeEventListener("focus", onFocus);
            window.removeEventListener("blur", onBlur);
            };
        }, []);

        // return the status
        return focus;
    };

    const FocusDetector = () => {
        const focus = useHasFocus();
        // console.log(focus);
        return <></>;
    };
        
    const routeParams = useParams();

    const [appointments, setAppointments] = useState([]);

    const [message, setMessage] = useState('loading...');

    useEffect(() => {
        const interval = setInterval(() => {
            fetchAppointments();
        }, 1000 * REFRESH_SECONDS);
        
        return () => clearInterval(interval);

    }, []);

    const updateEstTime = (appointmentDatas) => {
        // console.log("Appointment updateEstTime appointmentData", appointmentData);
        return Array.isArray(appointmentDatas) ? appointmentDatas.map((appt) => {
            const estTime = getEstimatedTime(
                appt.date,
                appt.start_time,
                appt.average_serve_minutes,
                appt.now_serving,
                appt.customer_number,
                appt.num_cancelled
            );
            return { ...appt, estTime };
            })
        : [];
    };

    // render list when URL has changed
    useEffect(() => {
        if (focus) fetchAppointments();
    }, [routeParams, focus]);

    const fetchAppointments = () => {
        console.log("fetchAppointments");
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/cust/list-appointments', {
            method: 'GET',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            }
        })
        .then(response => response.json())
        .then(data => {
            // console.log("appointments.data", data.data);
            if (data.message === "Unauthenticated.")
            {
                props.logout();
            }
            if (data.data)
            {
                const enriched = updateEstTime(data.data);
                setAppointments(enriched);
            } else {
                setAppointments([]);
                setMessage("(You have no appointments)");
            }
        })
        .catch((err) => {
            console.error(err);
        });
    }

    const [confirmCancelOpen, setConfirmCancelOpen] = useState(false);

    const [cancelId, setCancelId] = useState(null);

    const [cancelling, setCancelling] = useState(false);

    const onCancelButtonClick = (event) => {
        setConfirmCancelOpen(true);
        setCancelId(event.target.dataset.id);
    }

    const handleConfirmCancel = () => {
        cancelAppointment();
    }

    const cancelAppointment = () => {
        setCancelling(true);
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/cust/cancel-appointment/' + cancelId, {
            method: 'GET',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            }
        })
        .then(response => response.json())
        .then(() => {
            if (props.userType == USER_TYPE_GUEST) 
            {
                props.logout();
            }
            else {
                fetchAppointments();
                setCancelling(false);
            }
        })
        .catch((err) => {
            console.error(err);
            setCancelling(false);
        });
    }

    if (appointments && appointments.length > 0)
    {
        return (
            <React.Fragment>
                <Box sx={{ p: 1 }} >
                    <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                    {appointments.map(appointment => (
                        appointment.type == 1 ?
                        // dynamic queue
                        <AppointmentsListItem 
                            type={appointment.type}
                            estTime={appointment.estTime} 
                            key={appointment.id} 
                            appointment={appointment} 
                            onCancelButtonClick={onCancelButtonClick} 
                            cancelling={cancelling}
                        />
                        :
                        // fixed schedule
                        <AppointmentsListItemFixedSched 
                            type={appointment.type}
                            estTime={appointment.estTime} 
                            key={appointment.id} 
                            appointment={appointment} 
                            onCancelButtonClick={onCancelButtonClick} 
                            cancelling={cancelling}
                        />
                    ))} 
                    </List>
                </Box>
                
                <ConfirmDialog
                    title="Cancel Appointment?"
                    open={confirmCancelOpen}
                    setOpen={setConfirmCancelOpen}
                    onConfirm={handleConfirmCancel}
                >
                    Are you sure you want to cancel this appointment? This action cannot be reversed.
                    { props.userType == USER_TYPE_GUEST ? " Continuing will sign you out of the app immediately." : null  }
                </ConfirmDialog>
                <FocusDetector />
            </React.Fragment>
            
        );
    } else
    {
        return (
            <React.Fragment>
                <Box sx={{ p: 2 }} >
                    <Stack spacing={2} alignItems='center'>
                        <Typography variant="body1" component="div">
                        {message}
                        </Typography>
                    </Stack>
                </Box>
            </React.Fragment>
        );
    }
}

export default Appointments;